import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { notificationConstant } from "../constants/constants";


class NotificationStore extends EventEmitter {
    constructor() {
        super();
        this.notifications = [];
        // console.log("notification-----------", notificationConstant);
    }

    getAll() {
        return this.notifications;
    }
    getNoOfNotification() {
        return this.notifications.length;
    }

    handleAction(action) {
        switch (action.type) {
            case notificationConstant.FETCHED_ALL_NOTIFICATION: {
                this.notifications = action.data;
                this.emit(notificationConstant.FETCHED_ALL_NOTIFICATION);
                break;
            }
            case notificationConstant.NOTIFICATION_FETCH_FAILED: {
                this.emit(notificationConstant.NOTIFICATION_FETCH_FAILED, "Failed to get notification");
                break;
            }
            default:
                break;
        }
    }
}

const notificationStore = new NotificationStore();
dispatcher.register(notificationStore.handleAction.bind(notificationStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
export default notificationStore;


// WEBPACK FOOTER //
// ./src/jsx/store/notification-store.jsx